import React from 'react';

import classes from './FlexRow.module.scss';

const flexRow = (props) => {
	if(props.dir) {
		return (
			<div dir={props.dir} className={[classes.FlexRow, props.className].join(' ')}>
				{props.children}
			</div>
		);
	}
	
	return (
		<div className={[classes.FlexRow, props.className].join(' ')}>
			{props.children}
		</div>
	);
}

export default flexRow;